'use client';

import { useEffect } from 'react';

const BADGE_CLASS = 'show-recaptcha-badge';

/**
 * Hook to control reCAPTCHA badge visibility.
 *
 * The badge is hidden by default via CSS. This hook adds/removes a class
 * on the document body to show the badge when needed (e.g., during AI chat).
 *
 * Per Google's reCAPTCHA ToS, if the badge is hidden, disclosure text must be shown.
 *
 * @param visible - Whether the reCAPTCHA badge should be visible
 */
export function useRecaptchaBadge(visible: boolean): void {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    if (visible) {
      document.body.classList.add(BADGE_CLASS);
    } else {
      document.body.classList.remove(BADGE_CLASS);
    }

    return () => {
      document.body.classList.remove(BADGE_CLASS);
    };
  }, [visible]);
}
